import styled from 'styled-components';
import { Wrapper } from '../SavingsWorkspace/savingsworkspace.style';

export const AgenticWrapper = styled(Wrapper)`
  background: linear-gradient(180deg, #f7faff 0%, #ffffff 100%);
`;

export const FactList = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    background: #fff;
    color: #343d48cc;
    font-size: 15px;
    line-height: 1.7;
  }

  strong {
    color: #0f2137;
    font-weight: 600;
  }

  @media (max-width: 767px) {
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;
  }
`;

export const Closing = styled.div`
  max-width: 760px;
  margin: 32px auto 0;
  text-align: center;

  p {
    margin: 0 0 12px;
    color: #343d48;
    font-size: 15px;
    line-height: 1.75;
  }

  a {
    display: inline-block;
    padding: 10px 22px;
    border-radius: 4px;
    background: #335d9f;
    color: #fff;
    font-weight: 600;
  }
`;

export const Shot = styled.figure`
  max-width: 960px;
  margin: 40px auto 0;

  figcaption {
    margin-top: 10px;
    color: #5d646d;
    font-size: 14px;
    line-height: 1.6;
    text-align: center;
  }
`;
